export const getCookies = () => {
    if (document.cookie) {
        return Object.fromEntries(document.cookie.split('; ').map((c) => c.split('=')));
    }
    return {};
};
